<template>
    <v-row justify="center">
       
        <v-col cols="4" sm="3" md="2" lg="1" xl="1" >
            <div style="width:130px">
                <v-img
                    :contain="true"      
                    :src="src"
                ></v-img>
            </div> 
        </v-col>

    </v-row>
</template>

<script>
export default {

    props:[
        "srcProp"
    ],

    data: function(){
        return{
            src: this.srcProp
        }
    },

    watch:{
        srcProp(val){
            this.src = val
        }
    }



}
</script>

<style>

</style>